import React from "react";
import "../App.css";
import HeroSection from "./HeroSection";
import CoursesSection from "./CoursesSection";
import ContactusSection from "./ContactusSection";
import Address from "./Address";
import Review from "./Review";
import Motivator from "./Motivator";
import BusinessSolution from "./BusinessSolution";

function Home() {
  return (
    <>
      <HeroSection />
      <CoursesSection />
      <BusinessSolution />
      <Address />
      <Motivator />
      <Review />

      <ContactusSection />
    </>
  );
}

export default Home;
